import styled from 'styled-components';
import InningState from '@mlb/react-patterns/v4/components/InningState/inningState';
import COLORMAP from 'bdata-sns-shared/style/universal.color';
import { StyledOutsWrapper } from '@mlb/react-patterns/v4/components/InningState/inningState.style';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';

const {
    mlbGrey5
} = COLORS;

export const GameDataLayerWrapper = styled.div`
    flex: 1;
    height: 100%;
    position: relative;  
`;

export const GameDataLayerWrapperWithSeparator = styled(GameDataLayerWrapper)`
    &:before {
        content: '';
        position: absolute;
        width: 1px;
        height: 84%;
        left: 0px;
        top: 8%;
        background-color: ${COLORMAP.borderColor};
    }
`;

export const GameDataLayerContentWrapper = styled.div.attrs({
    'data-mlb-test': 'gameStateContainerDesktop'
})`
    position: absolute;
    top: calc(50% - ${({ isGameday }) => isGameday ? '4px' : '2px'});
    transform: translateY(-50%);
    width: 100%;
    text-align: center;
    box-sizing: border-box !important;
    width: 25px;
    margin-left: 8px;
`;

export const ViewingActiveGameWrapper = styled.div`
    font-size: 14px;
    line-height: 14px;
    margin-top: 16px;
    margin-right: 8px;
    color: ${mlbGrey5};
    font-weight: bold;
`;

export const InningStateOverride = styled(InningState)`
    &&& {
        margin: 0 auto;
    }    

    ${StyledOutsWrapper} {
        margin-top: 4px;
    }
`;

export const GameStateBaseLabelWrapper = styled.span``;
